import circleBeamSketch from "../Art/circleBeam";
import circlesSketch from "../Art/circles";
import nightskySketch from "../Art/nightsky";
import debrisSketch from "../Art/debris";
import whitePinkSketch from "../Art/whitePink";
import mortDAfnanSketch from "../Art/mortDAfnan";

const artDirectory = [
  circleBeamSketch,
  circlesSketch,
  nightskySketch,
  debrisSketch,
  whitePinkSketch,
  mortDAfnanSketch,
];

export default artDirectory;
